'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('shop', {
      url: '/shop',
      template: '<shop></shop>'
    });
}



// WEBPACK FOOTER //
// ./client/app/shop/shop.routes.js